import React from 'react';

import EntityProfile from 'components/EntityPage/EntityProfile';
import entitySchema from '../schema';

const Profile = ({ entity, entityInfos, onActivityLogSubmitHandler }) => {
  return (
    <EntityProfile
      entity={entity}
      entityInfos={entityInfos}
      entitySchema={entitySchema}
      onActivityLogSubmitHandler={onActivityLogSubmitHandler}
    />
  );
};

export default Profile;
